import React from "react";
import { Link } from "react-router-dom";

import Navbar from "./Navbar";
import Fa from "../common/Fa";
import historyHelper from "../../helpers/history-helper";
import queryString from "querystring";
import keycloakHelper from "../../helpers/keycloak-helper";

export default class TopMenu extends React.Component {
  /**
   * Almacena el estado del componente.
   */
  state = {
    loggedIn: false
  };

  /**
   * Se encarga de recuperar el estado de la sessión y lo guarda
   * en el estado del componente.
   */
  componentDidMount() {
    this.setState({ loggedIn: keycloakHelper.loggedIn });
  }

  /**
   * Se encarga de renderizar los elementos del menú.
   */
  renderItems() {
    if (!this.state.loggedIn) {
      return (
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons">
              <a
                className="button is-text is-primary"
                onClick={evt => this.login(evt)}
              >
                <Fa icon="user-circle" />
                Ingresar
              </a>
            </div>
          </div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <div className="navbar-start">
          <Link to="/visor" className="navbar-item">
            Visor
          </Link>

        </div>
        <div className="navbar-end">
          <div className="navbar-item">
            <div className="buttons">
              <a
                className="button is-text is-primary"
                onClick={evt => this.logout(evt)}
              >
                <Fa icon="power-off" />Salir
              </a>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
  /**
   * Se encarga de disparar el login.
   */
  login() {
    keycloakHelper.login();
  }

  /**
   * Se encarga de disparar el logout y acutaliza el estado del componente.
   */
  logout() {
    keycloakHelper.logout();
    this.setState({ loggedIn: false });
  }

  /**
   * Se encarga de renderizar el componente.
   */
  render() {
    let query = historyHelper.location.search;
    let args = queryString.parse(query.substring(1));
    if (args.visor) {
      return <div />;
    }
    return (
      <Navbar
        brand={
          <a className="navbar-item">
            <Fa icon="map-marked-alt" />
            &nbsp;SNC
          </a>
        }
      >
        {this.renderItems()}
      </Navbar>
    );
  }
}
